// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".large::-moz-placeholder{color:#222}\n.large::placeholder{color:#222}", "",{"version":3,"sources":["/home/saga-tsuku/app/saga-tsuku-members/app/javascript/stylesheets/react_large_popup_button.scss"],"names":[],"mappings":"AACE,yBACE,UAAA;AADF,oBACE,UAAA","file":"react_large_popup_button.scss","sourcesContent":[".large {\n  &::placeholder {\n    color: #222;\n  }\n}"]}]);
// Exports
module.exports = exports;
